<template>
  <div class="main-wrapper">
    <p class="no-entity" v-if="informationEntity.length == 0">
      Данные об участниках-юридических лицах-резидентах отсутствуют
    </p>
    <div v-if="informationEntity.length > 0">
      <div
        class="main-entities"
        v-for="info in informationEntity"
        :key="info.id"
      >
        <div class="show-title" @click="changeShow(info)">
          <p>
            <span :class="info.valid ? 'valid-field' : 'unvalid-field'">➤</span>
            {{ info.ORG_FULL_NAME }}
          </p>
          <div class="icons">
            <i class="fa fa-angle-up" v-if="info.show"></i>
            <i class="fa fa-angle-down" v-if="!info.show"></i>
          </div>
        </div>
        <div v-show="info.show && info.FOREIGN_REG_NUMBER == null">
          <table>
            <tr>
              <td class="left-column">
                <p>Доля, %</p>
              </td>
              <td class="right-column">
                <input type="text" v-model="info.PAY" disabled />
              </td>
            </tr>
            <tr>
              <td class="left-column">
                <p>Полное наименование организации</p>
              </td>
              <td class="right-column">
                <input type="text" v-model="info.ORG_FULL_NAME" disabled />
              </td>
            </tr>
            <tr>
              <td class="left-column">
                <p>Краткое наименование организации</p>
              </td>
              <td class="right-column">
                <input type="text" v-model="info.ORG_BRIEF_NAME" disabled />
              </td>
            </tr>
            <tr>
              <td>
                <p>ИНН</p>
              </td>
              <td>
                <input
                  type="text"
                  v-model="info.INN"
                  v-mask="'############'"
                  disabled
                />
              </td>
            </tr>
            <tr>
              <td>
                <p>ОГРН</p>
              </td>
              <td>
                <input
                  type="text"
                  v-model="info.OGRN"
                  v-mask="'#############'"
                  disabled
                />
              </td>
            </tr>
            <tr v-if="info.PAY >= 25">
              <td>
                <p class="necessary-bold">Налоговый статус</p>
              </td>
              <td>
                <dropdown
                  :options="taxesStatuses"
                  :selected="{ name: info.TAX_STATUS }"
                  placeholder="Выберите статус"
                  v-on:updateOption="onSelectTaxesStatus($event, info)"
                  :disabled="
                    info.DISABLED != null &&
                      info.DISABLED.indexOf('TAX_STATUS') != -1
                  "
                ></dropdown>
              </td>
            </tr>
            <tr v-if="info.PAY >= 25">
              <td>
                <p>Юридический адрес</p>
              </td>
              <td>
                <input
                  type="text"
                  v-model="info.UR_ADDRESS"
                  :onchanged="
                    info.UR_ADDRESS != null && info.UR_ADDRESS.length > 1000
                      ? (info.UR_ADDRESS = info.UR_ADDRESS.substr(0, 1000))
                      : info.UR_ADDRESS
                  "
                  disabled
                />
              </td>
            </tr>
            <tr v-if="info.PAY >= 25">
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      info.FACT_ADDRESS != null && info.FACT_ADDRESS.length > 0
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Фактический адрес
                </p>
                <label>
                  <input
                    type="checkbox"
                    v-model="info.live_like_registration"
                    :checked="factAddress(info)"
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('FACT_ADDRESS') != -1
                    "
                  />Cовпадает с юридическим адресом
                </label>
              </td>
              <td>
                <input
                  type="text"
                  v-model="info.FACT_ADDRESS"
                  :disabled="
                    info.live_like_registration ||
                      (info.DISABLED != null &&
                        info.DISABLED.indexOf('FACT_ADDRESS') != -1)
                  "
                  :onchanged="
                    info.FACT_ADDRESS != null && info.FACT_ADDRESS.length > 1000
                      ? (info.FACT_ADDRESS = info.FACT_ADDRESS.substr(0, 1000))
                      : info.FACT_ADDRESS
                  "
                />
              </td>
            </tr>
            <tr v-if="info.PAY >= 25">
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      info.BF_POSITION != null && info.BF_POSITION.length > 0
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Адрес из устава
                </p>
                <div class="checkboxes">
                  <label>
                    <input
                      type="checkbox"
                      v-model="info.ustav_like_addresses[0]"
                      :checked="bfAddress(info)"
                      @click="info.ustav_like_addresses[1] = false"
                      :disabled="
                        info.DISABLED != null &&
                          info.DISABLED.indexOf('BF_POSITION') != -1
                      "
                    />Cовпадает с юридическим адресом
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      v-model="info.ustav_like_addresses[1]"
                      :checked="bfAddress()"
                      @click="info.ustav_like_addresses[0] = false"
                      :disabled="
                        info.DISABLED != null &&
                          info.DISABLED.indexOf('BF_POSITION') != -1
                      "
                    />Cовпадает с фактичеcким адресом
                  </label>
                </div>
              </td>
              <td>
                <input
                  type="text"
                  v-model="info.BF_POSITION"
                  :disabled="
                    info.ustav_like_addresses[0] ||
                      info.ustav_like_addresses[1] ||
                      (info.DISABLED != null &&
                        info.DISABLED.indexOf('BF_POSITION') != -1)
                  "
                  :onchanged="
                    info.BF_POSITION != null && info.BF_POSITION.length > 1000
                      ? (info.BF_POSITION = info.BF_POSITION.substr(0, 1000))
                      : info.BF_POSITION
                  "
                />
              </td>
            </tr>
            <tr v-if="info.PAY >= 25">
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      info.POST_ADDRESS != null && info.POST_ADDRESS.length > 0
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Почтовый адрес
                </p>
                <div class="checkboxes">
                  <label>
                    <input
                      type="checkbox"
                      v-model="info.mail_like_addresses[0]"
                      :checked="postAddress(info)"
                      @click="info.mail_like_addresses[1] = false"
                      :disabled="
                        info.DISABLED != null &&
                          info.DISABLED.indexOf('POST_ADDRESS') != -1
                      "
                    />Cовпадает с юридическим адресом
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      v-model="info.mail_like_addresses[1]"
                      :checked="postAddress(info)"
                      @click="info.mail_like_addresses[0] = false"
                      :disabled="
                        info.DISABLED != null &&
                          info.DISABLED.indexOf('POST_ADDRESS') != -1
                      "
                    />Cовпадает с фактичеcким адресом
                  </label>
                </div>
              </td>
              <td>
                <input
                  type="text"
                  v-model="info.POST_ADDRESS"
                  :disabled="
                    info.mail_like_addresses[0] ||
                      info.mail_like_addresses[1] ||
                      (info.DISABLED != null &&
                        info.DISABLED.indexOf('POST_ADDRESS') != -1)
                  "
                  :onchanged="
                    info.POST_ADDRESS != null && info.POST_ADDRESS.length > 1000
                      ? (info.POST_ADDRESS = info.POST_ADDRESS.substr(0, 1000))
                      : info.POST_ADDRESS
                  "
                />
              </td>
            </tr>
            <tr v-if="info.PAY >= 25">
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      info.PHONE_NUMBER == null ||
                      info.PHONE_NUMBER.length == 0 ||
                      info.PHONE_NUMBER.length > 8
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Телефон
                </p>
              </td>
              <td>
                <div class="phone">
                  +
                  <input
                    type="text"
                    v-model="info.PHONE_NUMBER"
                    :onchanged="fPhoneChanged(info)"
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('PHONE_NUMBER') != -1
                    "
                  />
                </div>
              </td>
            </tr>
            <tr v-if="info.PAY >= 25">
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      info.E_MAIL == null ||
                      info.E_MAIL.length == 0 ||
                      (!info.unvalidEmail && info.E_MAIL.length > 8)
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Адрес электронной почты
                </p>
              </td>
              <td>
                <input
                  type="text"
                  v-model="info.E_MAIL"
                  placeholder="example@mail.com"
                  @blur="checkEmail(info)"
                  :onchanged="
                    info.E_MAIL != null && info.E_MAIL.length > 100
                      ? (info.E_MAIL = info.E_MAIL.substr(0, 100))
                      : info.E_MAIL
                  "
                  :disabled="
                    info.DISABLED != null &&
                      info.DISABLED.indexOf('E_MAIL') != -1
                  "
                />
                <p class="necessary-message" v-if="info.unvalidEmail">
                  Введите корректный адрес электронной почты
                </p>
              </td>
            </tr>
          </table>

          <div class="data-is-right-checkboxes">
            <label>
              <input
                type="checkbox"
                v-model="info.dataIsRight[0]"
                @click="info.dataIsRight = [info.dataIsRight[0], false]"
                :disabled="
                  info.DISABLED != null &&
                    info.DISABLED.indexOf('IS_DATA_VALID') != -1
                "
              />Данные верны
            </label>
            <label>
              <input
                type="checkbox"
                v-model="info.dataIsRight[1]"
                @click="
                  info.dataIsRight = [false, info.dataIsRight[1]];
                  info.ENTITY_FOUNDER_LIST_INVALID_DATA = '';
                "
                :disabled="
                  info.DISABLED != null &&
                    info.DISABLED.indexOf('IS_DATA_VALID') != -1
                "
              />Внести изменения
            </label>
          </div>
          <div v-show="info.dataIsRight[1]" class="invalid-data">
            <p class="necessary-bold">
              <span
                :class="
                  (info.ENTITY_FOUNDER_LIST_INVALID_DATA != null &&
                    info.ENTITY_FOUNDER_LIST_INVALID_DATA.length > 0) ||
                  !info.dataIsRight[1]
                    ? 'valid-field'
                    : 'unvalid-field'
                "
                >➤</span
              >
              Укажите строку, в которой указаны неверные данные и укажите верные
              данные
            </p>
            <textarea
              class="invalid-data-textarea"
              v-model="info.ENTITY_FOUNDER_LIST_INVALID_DATA"
              :disabled="
                info.DISABLED != null &&
                  info.DISABLED.indexOf('ENTITY_FOUNDER_LIST_INVALID_DATA') !=
                    -1
              "
            ></textarea>
          </div>
        </div>
        <div v-show="info.show && info.FOREIGN_REG_NUMBER != null">
          <table>
            <tr>
              <td class="left-column">
                <p>Доля, %</p>
              </td>
              <td class="right-column">
                <input type="text" v-model="info.PAY" disabled />
              </td>
            </tr>
            <tr>
              <td class="left-column">
                <p>Полное наименование организации</p>
              </td>
              <td class="right-column">
                <input type="text" v-model="info.ORG_FULL_NAME" disabled />
              </td>
            </tr>
            <tr>
              <td class="left-column">
                <p>Краткое наименование организации</p>
              </td>
              <td class="right-column">
                <input type="text" v-model="info.ORG_BRIEF_NAME" disabled />
              </td>
            </tr>
            <tr>
              <td>
                <p>Иностранный регистрационный номер</p>
              </td>
              <td>
                <input type="text" v-model="info.FOREIGN_REG_NUMBER" disabled />
              </td>
            </tr>
            <tr>
              <td>
                <p>ОГРН</p>
              </td>
              <td>
                <input
                  type="text"
                  v-model="info.OGRN"
                  v-mask="'#############'"
                  disabled
                />
              </td>
            </tr>
            <tr>
              <td>
                <p>Страна</p>
              </td>
              <td>
                <input
                  type="text"
                  v-model="info.COUNTRY_NAME"
                  :onchanged="
                    info.COUNTRY_NAME != null && info.COUNTRY_NAME.length > 255
                      ? (info.COUNTRY_NAME = info.COUNTRY_NAME.substr(0, 255))
                      : info.COUNTRY_NAME
                  "
                  disabled
                />
              </td>
            </tr>
            <tr v-if="info.PAY >= 25">
              <td>
                <p class="necessary-bold">Налоговый статус</p>
              </td>
              <td>
                <dropdown
                  :options="taxesStatuses"
                  :selected="{ name: info.TAX_STATUS }"
                  placeholder="Выберите статус"
                  v-on:updateOption="onSelectTaxesStatus($event, info)"
                  :disabled="
                    info.DISABLED != null &&
                      info.DISABLED.indexOf('TAX_STATUS') != -1
                  "
                ></dropdown>
              </td>
            </tr>
            <tr v-if="info.PAY >= 25">
              <td>
                <p>Юридический адрес</p>
              </td>
              <td>
                <input
                  type="text"
                  v-model="info.UR_ADDRESS"
                  :onchanged="
                    info.UR_ADDRESS != null && info.UR_ADDRESS.length > 1000
                      ? (info.UR_ADDRESS = info.UR_ADDRESS.substr(0, 1000))
                      : info.UR_ADDRESS
                  "
                  disabled
                />
              </td>
            </tr>
            <tr v-if="info.PAY >= 25">
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      info.FACT_ADDRESS != null && info.FACT_ADDRESS.length > 0
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Фактический адрес
                </p>
                <label>
                  <input
                    type="checkbox"
                    v-model="info.live_like_registration"
                    :checked="factAddress(info)"
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('FACT_ADDRESS') != -1
                    "
                  />Cовпадает с юридическим адресом
                </label>
              </td>
              <td>
                <input
                  type="text"
                  v-model="info.FACT_ADDRESS"
                  :disabled="
                    info.live_like_registration ||
                      (info.DISABLED != null &&
                        info.DISABLED.indexOf('FACT_ADDRESS') != -1)
                  "
                  :onchanged="
                    info.FACT_ADDRESS != null && info.FACT_ADDRESS.length > 1000
                      ? (info.FACT_ADDRESS = info.FACT_ADDRESS.substr(0, 1000))
                      : info.FACT_ADDRESS
                  "
                />
              </td>
            </tr>
            <tr v-if="info.PAY >= 25">
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      info.BF_POSITION != null && info.BF_POSITION.length > 0
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Адрес из устава
                </p>
                <div class="checkboxes">
                  <label>
                    <input
                      type="checkbox"
                      v-model="info.ustav_like_addresses[0]"
                      :checked="bfAddress(info)"
                      @click="
                        info.ustav_like_addresses = [
                          info.ustav_like_addresses[0],
                          false,
                        ]
                      "
                      :disabled="
                        info.DISABLED != null &&
                          info.DISABLED.indexOf('BF_POSITION') != -1
                      "
                    />Cовпадает с юридическим адресом
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      v-model="info.ustav_like_addresses[1]"
                      :checked="bfAddress(info)"
                      @click="
                        info.ustav_like_addresses = [
                          false,
                          info.ustav_like_addresses[1],
                        ]
                      "
                      :disabled="
                        info.DISABLED != null &&
                          info.DISABLED.indexOf('BF_POSITION') != -1
                      "
                    />Cовпадает с фактичеcким адресом
                  </label>
                </div>
              </td>
              <td>
                <input
                  type="text"
                  v-model="info.BF_POSITION"
                  :disabled="
                    info.ustav_like_addresses[0] ||
                      info.ustav_like_addresses[1] ||
                      (info.DISABLED != null &&
                        info.DISABLED.indexOf('BF_POSITION') != -1)
                  "
                  :onchanged="
                    info.BF_POSITION != null && info.BF_POSITION.length > 1000
                      ? (info.BF_POSITION = info.BF_POSITION.substr(0, 1000))
                      : info.BF_POSITION
                  "
                />
              </td>
            </tr>
            <tr v-if="info.PAY >= 25">
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      info.POST_ADDRESS != null && info.POST_ADDRESS.length > 0
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Почтовый адрес
                </p>
                <div class="checkboxes">
                  <label>
                    <input
                      type="checkbox"
                      v-model="info.mail_like_addresses[0]"
                      :checked="postAddress(info)"
                      @click="
                        info.main_like_addresses = [
                          info.main_like_addresses[0],
                          false,
                        ]
                      "
                      :disabled="
                        info.DISABLED != null &&
                          info.DISABLED.indexOf('POST_ADDRESS') != -1
                      "
                    />Cовпадает с юридическим адресом
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      v-model="info.mail_like_addresses[1]"
                      :checked="postAddress(info)"
                      @click="
                        info.main_like_addresses = [
                          false,
                          info.main_like_addresses[1],
                        ]
                      "
                      :disabled="
                        info.DISABLED != null &&
                          info.DISABLED.indexOf('POST_ADDRESS') != -1
                      "
                    />Cовпадает с фактичеcким адресом
                  </label>
                </div>
              </td>
              <td>
                <input
                  type="text"
                  v-model="info.POST_ADDRESS"
                  :disabled="
                    info.mail_like_addresses[0] ||
                      info.mail_like_addresses[1] ||
                      (info.DISABLED != null &&
                        info.DISABLED.indexOf('POST_ADDRESS') != -1)
                  "
                  :onchanged="
                    info.POST_ADDRESS != null && info.POST_ADDRESS.length > 1000
                      ? (info.POST_ADDRESS = info.POST_ADDRESS.substr(0, 1000))
                      : info.POST_ADDRESS
                  "
                />
              </td>
            </tr>
            <tr v-if="info.PAY >= 25">
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      info.PHONE_NUMBER == null ||
                      info.PHONE_NUMBER.length == 0 ||
                      info.PHONE_NUMBER.length > 8
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Телефон
                </p>
              </td>
              <td>
                <div class="phone">
                  +
                  <input
                    type="text"
                    v-model="info.PHONE_NUMBER"
                    :onchanged="fPhoneChanged(info)"
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('PHONE_NUMBER') != -1
                    "
                  />
                </div>
              </td>
            </tr>
            <tr v-if="info.PAY >= 25">
              <td>
                <p class="necessary-bold">
                  <span
                    :class="
                      info.E_MAIL == null ||
                      info.E_MAIL.length == 0 ||
                      (!info.unvalidEmail && info.E_MAIL.length > 8)
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Адрес электронной почты
                </p>
              </td>
              <td>
                <input
                  type="text"
                  v-model="info.E_MAIL"
                  placeholder="example@mail.com"
                  @blur="checkEmail(info)"
                  :onchanged="
                    info.E_MAIL != null && info.E_MAIL.length > 100
                      ? (info.E_MAIL = info.E_MAIL.substr(0, 100))
                      : info.E_MAIL
                  "
                  :disabled="
                    info.DISABLED != null &&
                      info.DISABLED.indexOf('E_MAIL') != -1
                  "
                />
                <p class="necessary-message" v-if="info.unvalidEmail">
                  Введите корректный адрес электронной почты
                </p>
              </td>
            </tr>
          </table>

          <p
            class="necessary-table-not"
            v-if="!(info.dataIsRight[0] || info.dataIsRight[1])"
          >
            Подтвердите корректность данных, заполненных автоматически.
          </p>
          <div class="data-is-right-checkboxes">
            <label>
              <input
                type="checkbox"
                v-model="info.dataIsRight[0]"
                @click="info.dataIsRight = [info.dataIsRight[0], false]"
                :disabled="
                  info.DISABLED != null &&
                    info.DISABLED.indexOf('IS_DATA_VALID') != -1
                "
              />Данные верны
            </label>
            <label>
              <input
                type="checkbox"
                v-model="info.dataIsRight[1]"
                @click="
                  info.dataIsRight = [false, info.dataIsRight[1]];
                  info.ENTITY_FOUNDER_LIST_INVALID_DATA = '';
                "
                :disabled="
                  info.DISABLED != null &&
                    info.DISABLED.indexOf('IS_DATA_VALID') != -1
                "
              />Внести изменения
            </label>
          </div>
          <div v-show="info.dataIsRight[1]" class="invalid-data">
            <p class="necessary-bold">
              <span
                :class="
                  (info.ENTITY_FOUNDER_LIST_INVALID_DATA != null &&
                    info.ENTITY_FOUNDER_LIST_INVALID_DATA.length > 0) ||
                  !info.dataIsRight[1]
                    ? 'valid-field'
                    : 'unvalid-field'
                "
                >➤</span
              >
              Укажите строку, в которой указаны неверные данные и укажите верные
              данные
            </p>
            <textarea
              class="invalid-data-textarea"
              v-model="info.ENTITY_FOUNDER_LIST_INVALID_DATA"
              :disabled="
                info.DISABLED != null &&
                  info.DISABLED.indexOf('ENTITY_FOUNDER_LIST_INVALID_DATA') !=
                    -1
              "
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dropdown from "vue-dropdowns";
import mask from "./utils/my-mask.js";
export default {
  name: "EntitiesFounderInfo",
  props: {
    pageInfo: {},
    pageName: String,
  },
  components: { dropdown },
  data: () => ({
    informationEntity: [],
    clickShow: false,
    taxesStatuses: [
      {
        name: "Резидент",
      },
      {
        name: "Нерезидент",
      },
    ],
    sendData: {},
  }),
  methods: {
    onSelectTaxesStatus(event, member) {
      member.TAX_STATUS = event.name;
    },
    changeShow(info) {
      info.show = !info.show;
      this.clickShow = true;
    },
    factAddress(item) {
      if (item != null && item.live_like_registration)
        item.FACT_ADDRESS = item.UR_ADDRESS;
    },
    bfAddress(item) {
      if (item != null && item.ustav_like_addresses[0])
        item.BF_POSITION = item.UR_ADDRESS;
      else if (item != null && item.ustav_like_addresses[1])
        item.BF_POSITION = item.FACT_ADDRESS;
    },
    postAddress(item) {
      if (item != null && item.mail_like_addresses[0])
        item.POST_ADDRESS = item.UR_ADDRESS;
      else if (item != null && item.mail_like_addresses[1])
        item.POST_ADDRESS = item.FACT_ADDRESS;
    },
    checkInformationEntity(item) {
      var msg = "";
      msg += "Для " + item.ORG_BRIEF_NAME + " заполните поля:<br>";
      if (item.PAY >= 25) {
        if (item.FACT_ADDRESS == null || item.FACT_ADDRESS.length == 0)
          msg += "• Фактический адрес<br>";
        if (item.BF_POSITION == null || item.BF_POSITION.length == 0)
          msg += "• Адрес из Устава<br>";
        if (item.POST_ADDRESS == null || item.POST_ADDRESS.length == 0)
          msg += "• Почтовый адрес<br>";
        if (item.unvalidEmail) msg += "• Адрес электронной почты<br>";
        if (
          item.PHONE_NUMBER != null &&
          item.PHONE_NUMBER.length > 0 &&
          item.PHONE_NUMBER.length <= 8
        )
          msg += "• Телефон<br>";
      }
      if (
        item.dataIsRight[1] &&
        (item.ENTITY_FOUNDER_LIST_INVALID_DATA == null ||
          item.ENTITY_FOUNDER_LIST_INVALID_DATA.length == 0)
      )
        msg +=
          "• Укажите строку, в которой указаны неверные данные и укажите верные данные<br>";
      if (!(item.dataIsRight[0] || item.dataIsRight[1]))
        msg +=
          "• Подтвердите корректность данных, заполненных автоматически<br>";
      if (msg.indexOf("•") != -1) return msg;
      else return "";
    },
    fPhoneChanged(info) {
      if (info.PHONE_NUMBER != null && info.PHONE_NUMBER.length > 13)
        info.PHONE_NUMBER = info.PHONE_NUMBER.substr(0, 13);
      if (info.PHONE_NUMBER != null)
        info.PHONE_NUMBER = info.PHONE_NUMBER.replace(/[^0-9]/g, "");
    },
    fillFoundersEntity(data) {
      if (data.TAX_STATUS == null || data.TAX_STATUS)
        data.TAX_STATUS = "Резидент";
      else data.TAX_STATUS = "Нерезидент";
      data.show = false;
      if (data.ENTITY_FOUNDER_LIST_INVALID_DATA == null)
        data.ENTITY_FOUNDER_LIST_INVALID_DATA = "";
      if (data.IS_DATA_VALID != null)
        data.dataIsRight = [data.IS_DATA_VALID, !data.IS_DATA_VALID];
      else data.dataIsRight = [false, false];
      if (data.FACT_ADDRESS == null) data.FACT_ADDRESS = "";
      if (data.BF_POSITION == null) data.BF_POSITION = "";
      if (data.POST_ADDRESS == null) data.POST_ADDRESS = "";
      if (data.E_MAIL == null) data.E_MAIL = "";
      if (data.PHONE_NUMBER == null) data.PHONE_NUMBER = "";
      data.live_like_registration = false;
      data.valid = false;
      data.mail_like_addresses = [false, false];
      data.ustav_like_addresses = [false, false];
      data.unvalidEmail = false;
      if (data.ORG_FULL_NAME == null) data.ORG_FULL_NAME = "";
    },
    validation() {
      var msg = "";
      this.informationEntity.forEach((item) => {
        var tmp_msg = this.checkInformationEntity(item);
        item.valid = tmp_msg.length == 0;
        msg += tmp_msg;
      });
      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        var info = JSON.parse(JSON.stringify(this.informationEntity));
        info.forEach((item) => {
          item.TAX_STATUS = item.TAX_STATUS == "Резидент";
          item.IS_DATA_VALID = item.dataIsRight[0];
        });
        this.sendData.EN_FOUNDERS = info;
        this.$emit("changePageSendData", this.sendData, false);
      }
    },
    checkEmail(data) {
      data.unvalidEmail = mask.emailCheck(data.E_MAIL);
    },
  },
  async created() {
    try {
      this.sendData.INN = this.pageInfo.INN;

      this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
      this.sendData.ID = this.pageInfo.ID;
      for (let i = 0; i < this.pageInfo.EN_FOUNDERS.length; i++) {
        this.pageInfo.EN_FOUNDERS[i].id = i;
        this.fillFoundersEntity(this.pageInfo.EN_FOUNDERS[i]);
      }
      this.informationEntity = JSON.parse(
        JSON.stringify(this.pageInfo.EN_FOUNDERS)
      );
      this.validation();
    } catch (error) {
      console.log(error);
    }

    this.$emit("buttons", false, true);
  },
  updated() {
    this.validation();

    if (!this.clickShow) this.$emit("updated");
    this.clickShow = false;
  },
};
</script>

<style scoped>
.main-entities {
  border: 1px solid #555555;
  margin-top: 10px;
}
.main-wrapper {
  text-align: justify;
}
.left-column {
  width: 30%;
  display: flex;
  flex-direction: column;
}
.right-column {
  width: 70%;
}
.checkboxes {
  display: flex;
  flex-direction: column;
}
table {
  border-collapse: collapse;
  padding: 0px 5px;
  width: 100%;
}
.show-title {
  width: 100%;
  margin-top: 10px;
  cursor: default;
  text-align: center;
}
.icons {
  background-color: white;
  border: none;
  color: black;
  position: relative;
  font-size: 15px;
}
input[type="text"] {
  border: none;
  width: 100%;
  border-bottom: 1px solid #cccccc;
  margin-left: 0px;
}
input[type="text"]:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
td {
  padding: 5px 10px;
}
tr {
  border-top: 1px solid black;
}
.necessary {
  color: red;
}
.data-is-right-checkboxes {
  text-align: center;
  padding: 5px 0px;
}
.no-entity {
  text-align: center;
}
.necessary-message {
  color: red;
  font-size: 12px;
}
.phone {
  display: flex;
  flex-direction: row;
}
</style>
